import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";

export default (props) => {
  const columns = [
    {
      field: "ic",
      label: "IČO",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      field: "subject",
      label: "Název",
      type: ColumnType.TEXT,
      width: "20%",
    },
    {
      field: "username",
      label: "Přihlašovací jméno",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "databox",
      label: "Datová schránka",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "officialsCount",
      label: "Počet funkcionářů",
      type: ColumnType.NUMBER,
      width: "11%",
    },
    {
      field: "createNote",
      label: "Důvod vytvoření",
      type: ColumnType.TEXT,
      width: "23%",
    },
    {
      field: "created",
      label: "Vytvořen",
      type: ColumnType.DATE,
      width: "12%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const OvmNoOfficialsGrid = (props) => {
  const columns = [
    {
      field: "ic",
      label: "IČO",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      field: "subject",
      label: "Název",
      type: ColumnType.TEXT,
      width: "25%",
    },
    {
      field: "username",
      label: "Přihlašovací jméno",
      type: ColumnType.TEXT,
      width: "13%",
    },
    {
      field: "databox",
      label: "Datová schránka",
      type: ColumnType.TEXT,
      width: "13%",
    },
    {
      field: "createNote",
      label: "Důvod vytvoření",
      type: ColumnType.TEXT,
      width: "25%",
    },
    {
      field: "created",
      label: "Vytvořen",
      type: ColumnType.DATE,
      width: "14%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};
